define((require) => {
    "use strict";

    const LoggedInUserState = require("shared/ui/user/LoggedInUserState");
    const MsSharedEntityModel  = require("ui/experienceOverview/experiencePermissions/MsSharedEntityModel");

    return {
        movePermissions({
            sourceID, sourceType, companyId, destID, destType
        }) {
            if (LoggedInUserState.get("companySettings").get("userPermissionsEnabled")) {
                // If we switch groups we also need to move the permissions over
                const sharedEntity = new MsSharedEntityModel({
                    entityId: sourceID,
                    companyId: companyId,
                    entityType: sourceType
                });

                sharedEntity.moveSharedEntity({
                    destID: destID,
                    destType: destType
                });
            }
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/experienceOverview/experiencePermissions/SharedEntityHelper.js